var SplitPane = require('./lib/SplitPane');

module.exports = SplitPane;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-split-pane/index.js
// module id = 801
// module chunks = 0